import React from "react";
import { Link } from "react-router-dom";
import Question from "../models/question";
import moment from "moment";

interface Props {
    question: Question.Flat;
}

export default React.memo<Props>((props) => {
    const displayText = props.question.title || props.question.question;
    const timeAgo = moment(props.question.created).fromNow();

    return (
        <Link
            to={`/document-library?question=${props.question.id}`}
            className="block"
        >
            <div className="flex flex-col gap-2 bg-[#ffffff0a] hover:bg-[#ffffff15] rounded-lg p-3 cursor-pointer transition-colors duration-200 border border-transparent hover:border-[#ffffff20]">
                <p className="text-white text-sm font-medium line-clamp-2 leading-snug">
                    {displayText}
                </p>
                <p className="text-[#717D96] text-xs">
                    {timeAgo}
                </p>
            </div>
        </Link>
    );
});
